<template>
  <b-modal
    v-model="isVisible"
    centered
    hide-header
    hide-header-close
    hide-footer
    content-class="!rounded-[12px]"
    body-class="!p-[1.5rem]"
    @hidden="onHidden"
  >
    <div class="flex justify-between items-center mb-[0.75rem]">
      <h4 class="!text-[18px] font-medium text-[#0A0A0A] mb-0">
        Perubahan belum disimpan
      </h4>
      <feather-icon
        icon="XIcon"
        size="20"
        class="cursor-pointer text-[#737373] hover:text-[#0A0A0A]"
        @click="close"
      />
    </div>
    <p class="mb-[1.75rem] text-[14px] text-[#737373]">
      Jika keluar sekarang, perubahan yang sudah kamu buat akan hilang. Yakin ingin keluar?
    </p>

    <div class="flex justify-end items-center mt-[1.25rem] gap-[0.5rem]">
      <b-button
        variant="ghost"
        size="sm"
        class="!text-[#737373] !font-normal !px-[1rem] !border-[1px] !border-[#E5E5E5] !py-[0.65rem] !shadow-[0px_1px_2px_0px_#0000001A] !rounded-[8px]"
        :disabled="isLoadingToDraft || isLoadingSubmit || disableDraft"
        @click="toDraft"
      >
        <b-spinner
          v-if="isLoadingToDraft"
          small
          class="mr-1"
        />
        Simpan ke Draft
      </b-button>
      <b-button
        variant="primary"
        class="!rounded-[8px] !px-[1rem] !py-[0.65rem] !flex items-center justify-center gap-[8px]"
        size="sm"
        :disabled="isLoadingToDraft || isLoadingSubmit"
        @click="submit"
      >
        <b-spinner
          v-if="isLoadingSubmit"
          small
        />
        <span>Keluar</span>
      </b-button>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'EditorUnsaveDialog',
  props: {
    disableDraft: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isVisible: false,
      isLoadingToDraft: false,
      isLoadingSubmit: false,
      onToDraftCallback: null,
      onSubmitCallback: null,
      item: {
        judul: '',
      },
    }
  },
  methods: {
    /**
     * Displays the unsaved changes dialog.
     * @param {Object} options - Dialog options.
     * @param {Function} [options.onSubmit] - Callback when exiting without saving.
     * @param {Function} [options.onToDraft] - Callback when saving to draft.
     * @param {Function} [options.onCancel] - Callback when dialog is closed.
     * @param {Object} [options.item] - Item data passed to callbacks.
     */
    show(options = {}) {
      this.onSubmitCallback = options.onSubmit || null
      this.onToDraftCallback = options.onToDraft || null
      this.onCancelCallback = options.onCancel || null
      this.isVisible = true

      this.item = options.item || {
        judul: '',
      }
    },
    /**
     * Handles the dialog hidden event to reset state.
     */
    onHidden() {
      this.item = {
        judul: '',
      }
      if (typeof this.onCancelCallback === 'function') {
        this.onCancelCallback()
      }
      this.onCancelCallback = null
      this.onSubmitCallback = null
      this.onToDraftCallback = null
    },
    close() {
      this.isVisible = false
    },
    /**
     * Triggers the save-to-draft flow if a callback is provided.
     */
    async toDraft() {
      if (typeof this.onToDraftCallback === 'function') {
        try {
          this.isLoadingToDraft = true
          await this.onToDraftCallback(this.item)
          this.onCancelCallback = null
          this.close()
        } catch (error) {
          this.$toast_error({ message: 'Gagal menyimpan ke draft' })
        } finally {
          this.isLoadingToDraft = false
        }
      } else {
        this.close()
      }
    },
    /**
     * Triggers the submission (exit) flow if a callback is provided.
     */
    async submit() {
      if (typeof this.onSubmitCallback === 'function') {
        try {
          this.isLoadingSubmit = true
          await this.onSubmitCallback(this.item)
          this.onCancelCallback = null
          this.close()
        } catch (error) {
          this.$toast_error({ message: 'Gagal menyimpan perubahan' })
        } finally {
          this.isLoadingSubmit = false
        }
      } else {
        this.close()
      }
    },
  },
}
</script>
